import axios from "axios";

const BaseUrl = process.env.REACT_APP_API_BASE_URL
const ImageUrl = process.env.REACT_APP_IMAGE_BASE_URL

export { BaseUrl, ImageUrl };


const api = axios.create({ baseURL: BaseUrl, withCredentials: true });
const addressApi = axios.create({ baseURL: ImageUrl, withCredentials: true });

const getAccessToken = () => {
    return localStorage.getItem("token");
};

api.interceptors.request.use(
    (config) => {
        const token = getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const res = await axios.post(
                    `${BaseUrl}/auth/refresh-token`,
                    {},
                    { withCredentials: true }
                );

                const newAccessToken = res.data.data.accessToken;
                if (newAccessToken) {
                    localStorage.setItem("token", newAccessToken);
                    api.defaults.headers.common[
                        "Authorization"
                    ] = `Bearer ${newAccessToken}`;
                    originalRequest.headers[
                        "Authorization"
                    ] = `Bearer ${newAccessToken}`;
                }

                return api(originalRequest);
            } catch (refreshError) {
                console.error("Refresh token failed:", refreshError);
                localStorage.removeItem("token");
                window.location.href = "/";
            }
        }

        return Promise.reject(error);
    }
);

addressApi.interceptors.request.use(
    (config) => {
        const token = getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);


//SIGN IN 

export const signInAdminApi = async (payloadData) => {
    try {
        const response = await api.post(`auth/login`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//CREATE CATEGORY 

export const createCategoryApi = async (payloadData) => {
    try {
        const response = await api.post(`product/create-category`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET CATEGORY 

export const getCategoryApi = async () => {
    try {
        const response = await api.get(`product/get-category`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE CATEGORY 

export const updateCategoryApi = async (payloadData, productId) => {
    try {
        const response = await api.put(`product/update-category/${productId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//DELETE CATEGORY 

export const deleteCategoryApi = async (productId) => {
    try {
        const response = await api.delete(`product/delete-category/${productId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET CONTACT INQUIRY 

export const getContactInquiryApi = async () => {
    try {
        const response = await api.get(`contactus/get-contacts`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}



//CREATE TESTIMONIALS

export const createTestimonialsApi = async (payloadData) => {
    try {
        const response = await api.post(`testimonials/create-testimonial`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET TESTIMONIALS

export const getTestimonialsApi = async () => {
    try {
        const response = await api.get(`testimonials/get-testimonials`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE TESTIMONIALS

export const updateTestimonialsApi = async (payloadData, productId) => {
    try {
        const response = await api.put(`testimonials/update-testimonial/${productId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//DELETE TESTIMONIALS

export const deleteTestimonialsApi = async (productId) => {
    try {
        const response = await api.delete(`testimonials/delete-testimonial/${productId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}


//CREATE SLIDER 

export const createSliderApi = async (payloadData) => {
    try {
        const response = await api.post(`slider/create`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET SLIDER 

export const getSliderApi = async () => {
    try {
        const response = await api.get(`slider/get`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE SLIDER 

export const updateSliderApi = async (payloadData, productId) => {
    try {
        const response = await api.put(`slider/update/${productId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//DELETE SLIDER 

export const deleteSliderApi = async (productId) => {
    try {
        const response = await api.delete(`slider/delete/${productId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//CREATE ADVERTISEMENT

export const createAdvertisementApi = async (payloadData) => {
    try {
        const response = await api.post(`advertisements/create`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}



//GET ADVERTISEMENT

export const getAdvertisementApi = async () => {
    try {
        const response = await api.get(`advertisements/get`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE ADVERTISEMENT

export const updateAdvertisementApi = async (payloadData, productId) => {
    try {
        const response = await api.put(`advertisements/update/${productId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"
    }
}

//DELETE ADVERTISEMENT

export const deleteAdvertisementApi = async (productId) => {
    try {
        const response = await api.delete(`advertisements/delete/${productId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//CREATE POPUP

export const createPopupApi = async (payloadData) => {
    try {
        const response = await api.post(`popupconfiguration/create`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET POPUP

export const getPopupApi = async () => {
    try {
        const response = await api.get(`popupconfiguration/get`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE POPUP

export const updatePopupApi = async (payloadData, productId) => {
    try {
        const response = await api.put(`popupconfiguration/update/${productId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//DELETE POPUP

export const deletePopupApi = async (productId) => {
    try {
        const response = await api.delete(`popupconfiguration/delete/${productId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//CREATE - UPDATE CONFIGURATION 

export const createUpdateConfigurationApi = async (payloadData) => {
    try {
        const response = await api.post(`configuration/create-update`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET CONFIGURATION 

export const getConfigurationApi = async (configurationType) => {
    try {
        const response = await api.get(`configuration/get?configurationType=${configurationType}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET DASHBOARD DETAILS

export const getDashboardDetailsApi = async () => {
    try {
        const response = await api.get(`dashboard`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//CREATE NEW PRODUCT

export const createNewProductApi = async (payloadData) => {
    try {
        const response = await api.post(`product/create-product`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE NEW PRODUCT

export const updateNewProductApi = async (payloadData, productId) => {
    try {
        const response = await api.put(`product/update-product/${productId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//GET PRODUCTS

export const getProductsApi = async ({ categoryId }) => {
    try {
        const response = await api.post(`product/get-product`, { categoryId });
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//DELETE PRODUCT 

export const deleteProductApi = async (productId) => {
    try {
        const response = await api.delete(`product/delete-product/${productId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

/* CHANGE CREDENTIALS */

//CHANGE EMAIL

export const changeEmailApi = async (payloadData) => {
    try {
        const response = await api.post(`auth/change-email`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//CHANGE PASSWORD

export const changePasswordApi = async (payloadData) => {
    try {
        const response = await api.post(`auth/change-password`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}


//CREATE ANNOUNCEMENT 

export const createAnnouncementApi = async (payloadData) => {
    try {
        const response = await api.post(`announcement/create`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response?.data?.message || error.message || "Check Network Connection"

    }
}

//UPDATE ANNOUNCEMENT 

export const updateAnnouncementApi = async (payloadData, announcementId) => {
    try {
        const response = await api.put(`announcement/update/${announcementId}`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response.data.message || "Check Network Connection"

    }
}

//DELETE ANNOUNCEMENT 

export const deleteAnnouncementApi = async (announcementId) => {
    try {
        const response = await api.delete(`announcement/delete/${announcementId}`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response.data.message || "Check Network Connection"

    }
}

//GET ANNOUNCEMENT 

export const getAnnouncementApi = async () => {
    try {
        const response = await api.get(`announcement/get`);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response.data.message || "Check Network Connection"

    }
}

//SET BEST SELLING PRODUCT

export const setBestSellingProductApi = async (payloadData) => {
    try {
        const response = await api.post(`product/create-or-update-best-selling-products`, payloadData);
        return response.data
    } catch (error) {
        console.log(error);
        throw error.response.data.message || "Check Network Connection"

    }
}




export { api, addressApi };


